import { css, styled } from 'canoe';
import React, { useEffect, useState } from 'react';

import { CraftMode } from 'craft/containers/Craft/Craft';
import { usePlacementMode, useViewportDom } from 'craft/state';
import { isDomElement } from 'craft/utils/viewport';

const LockOverlay = styled.div<{ top?: number; left?: number }>`
  ${({ top = 0, left = 0 }) => css`
    width: 100%;
    height: 100%;
    position: absolute;
    top: ${top}px;
    left: ${left}px;
    z-index: 1;
    cursor: not-allowed;
  `}
`;

export const EditorLockOverlay = ({ mode }: { mode: CraftMode }) => {
  const { placementMode } = usePlacementMode();
  const { viewportWrapperEl } = useViewportDom();

  const [offsets, setOffsets] = useState<{ scrollTop: number; scrollLeft: number }>({
    scrollTop: viewportWrapperEl?.scrollTop || 0,
    scrollLeft: viewportWrapperEl?.scrollLeft || 0,
  });

  const updateOffsets = () => {
    setOffsets({
      scrollTop: viewportWrapperEl?.scrollTop || 0,
      scrollLeft: viewportWrapperEl?.scrollLeft || 0,
    });
  };

  useEffect(() => {
    updateOffsets();

    if (mode !== 'locked' || placementMode) {
      return () => undefined;
    }

    if (isDomElement(viewportWrapperEl)) {
      viewportWrapperEl.addEventListener('scroll', updateOffsets);
    }

    return () => {
      if (isDomElement(viewportWrapperEl)) {
        viewportWrapperEl.removeEventListener('scroll', updateOffsets);
      }
    };
  }, [mode, placementMode]);

  if (mode !== 'locked' || placementMode) {
    return null;
  }

  return (
    <LockOverlay
      data-cy="editor-lock-overlay"
      onClick={(e) => e.stopPropagation()}
      top={offsets.scrollTop}
      left={offsets.scrollLeft}
    />
  );
};
